module.exports = __webpack_public_path__ + "static/media/carrorama-duvida.519de9db.png";